export function getdata() {
	let obj = {
		formdatajbxx: {
			cains: "",
			qij1: "",
			currency: "",
			qij2: ""
		},
		formlistjbxx: [{
				prop: "cains",
				label: "财务年度",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "qij1",
				label: "财务期间始",
				type: "select",
				selectval: [],
				isnotnull: true,

			},
			{
				prop: "currency",
				label: "币种	",
				type: "select",
				isnotnull: true,
				selectval: [{
					label: 'RMB',
					value: 'RMB'
				}],

			},
			{
				prop: "qij2",
				label: "财务期间止",
				type: "select",
				selectval: [],
				isnotnull: true,

			}
		],
		formdatazfkm: {
			zhongfkmStart: "",
			zhongfkmEnd: "",

		},
		formlistzfkm: [{
				prop: "zhongfkmStart",
				label: "中方科目始",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "zhongfkmEnd",
				label: "中方科目止",
				type: "select",
				selectval: [],
				isnotnull: true,

			},
		],
	}
	return obj
}
